import React from "react";

const About = () => {
  return (
    <div
      name="about"
      id="About"
      className="w-full h-auto min-h-screen bg-gradient-to-b from-gray-800 to-black text-white flex items-center"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full">
        <div className="pb-8">
          <p className="text-3xl md:text-4xl font-bold inline border-b-4 border-gray-500">
            About Me
          </p>
        </div>
        <p className=" text-base md:text-xl mt-4 leading-relaxed">
          Hello, I am Hitesh ,a business management graduate with a passion for
          technology. With several years of experience in the hospitality
          industry, I developed a keen understanding of customer service and
          operational efficiency.However, my curiosity and interest in creating
          web applications led me to pursue a career in full stack web
          development.
        </p>

      <p className ="text-base md:text-xl mt-4 leading-relaxed">
         Through a comprehensive bootcamp and continuous
          self-learning via online courses, have gained knowledge in both
          front-end and back-end development. I am currently lookimg for junior developer
          roles or an internship that will allow me to apply my skills, learn from
          experienced professionals, and grow within the industry. I am excited
          to contribute to projects that make a difference and to continue
          evolving as a developer.
      </p>
      </div>
    </div>
  );
};

export default About;
